import OutputtingDataTo from './OutputtingDataTo'

export default OutputtingDataTo
